import { render, staticRenderFns } from "./Presention-chart.vue?vue&type=template&id=14065602"
import script from "./Presention-chart.vue?vue&type=script&lang=js"
export * from "./Presention-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports